import dynamic from 'next/dynamic';

const DynamicFooter = dynamic(() => import('@components/Footer'), {
    ssr: true,
});

export default DynamicFooter;
